import React from 'react'
import {Wrapper} from './components/Styled'
import PropTypes from 'prop-types'

const AlertTemplate = ({options, message, close}) => (
  // the style contains only the margin given as offset
  // options contains all alert given options
  // message is the alert message...
  // close is a function that closes the alert
  <Wrapper type={options.type}>
    <button type='button' onClick={close}>&times;</button>
    <p dangerouslySetInnerHTML={{__html: message}} />
  </Wrapper>
)

AlertTemplate.displayName = 'AlertTemplate'

AlertTemplate.propTypes = {
  close: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  options: PropTypes.object.isRequired
}

export default AlertTemplate
